// Bubble text content for Mission 2 with highlights, keyboard layout conditionals, and fellow emotion.
// Bubble size is automatic based on text length.
// Optional per-page bubble layout overrides:
// - bubbleLeftPercent / bubbleBottomPercent
// - bubbleMinWidthPercent / bubbleMaxWidthPercent
// Optional per-page fellow emotion:
// - fellowEmotion: 'hq-happy' | 'hq-impressed' | 'hq-neutral' | 'hq-speaking'
// Each entry: { text: string, highlights: Array<{text?: string, conditional?: object}> }

const DEFAULT_LAYOUT_LABELS = {
 KeyZ: "Z",
 Slash: "/",
 KeyS: "S",
 KeyD: "D",
 KeyF: "F",
 KeyK: "K",
 KeyL: "L",
 Semicolon: ";",
 spaceKey: "Space",
};

export const MISSION_TWO_BUBBLE_TEXT = [
 // 1
 {
  text: `Now the streets get busier!\n\nTrucks are joining the game. Some are allies who try to help you. Others are mafia agents who try to trick you.\n\nYour mission: collect packages and decide who you can rely on.`,
  audioSrc: "assets/audio/instructions 2.1.mp3",
  fellowEmotion: "hq-happy",
  highlights: [
   { text: "allies" },
   { text: "who you can rely on" },
  ],
 },
 // 2
 {
  text: `Trucks may come from behind and move into your lane.\n\nSometimes you can stop them by tapping "{{Slash}}" to speed up.\n\nOther times, they will cut in no matter what.`,
  audioSrc: "assets/audio/instructions 2.2.mp3",
  fellowEmotion: "hq-speaking",
  highlights: [
   { text: "Sometimes" },
   { text: "stop" },
   { conditional: { key: "Slash" } },
  ],
 },
 // 3
 {
  text: `Trucks in front of you may suggest a lane (shown in the gray window above).\n\n  • If you trust the truck, follow their suggestion.\n  • If you don't trust the truck, press the {{spaceKey}} to push it aside and see the car yourself.\n  • Sometimes the truck won't move (you'll hear a sound).\n\nThen, use the same keys as before to choose your lane.`,
  audioSrc: "assets/audio/instructions 2.3.mp3",
  fellowEmotion: "hq-impressed",
  highlights: [
   { text: "trust the truck" },
   { text: "don't trust the truck" },
   { text: "Sometimes" },
   { conditional: { key: "spaceKey" } },
  ],
 },
 // 4
 {
  text: `If you ignore the truck, you'll see the car and its code directly.\n\n  • Each car's color shows its mafia type (see the box on the right).\n  • Use the same keys as before to select the correct lanes.`,
  audioSrc: "assets/audio/instructions 2.4.mp3",
  fellowEmotion: "hq-neutral",
  highlights: [
   { text: "car's color" },
   { text: "mafia type" },
  ],
 },
 // 5
 {
  text: `From time to time, I'll check in with you.\n\nA set of emoticons will appear.\nChoose the one that best matches how you feel in that moment.\nThe corresponding key will be shown under each icon.`,
  audioSrc: "assets/audio/instructions 2.5.mp3",
  fellowEmotion: "hq-impressed",
  highlights: [
   { text: "emoticons" },
   { text: "how you feel" },
   { text: "key" },
   { text: "under each icon" },
  ],
 },
 // 6
 {
  text: `You can go back and review if you'd like.\n\nOnce you continue, the mission will begin and these messages will disappear.\n\nTip: While in a lane, you can adjust speed by tapping {{Slash}} to go faster or {{KeyZ}} to slow down.`,
  audioSrc: "assets/audio/instructions 2.6.mp3",
  fellowEmotion: "hq-happy",
  highlights: [
   { text: "adjust speed" },
   { conditional: { key: "Slash" } },
   { conditional: { key: "KeyZ" } },
  ],
 },
];

function buildLabelsFromLayoutConfig(layoutConfig) {
 return {
  ...DEFAULT_LAYOUT_LABELS,
  KeyZ: layoutConfig?.backwardSlowDownKey ?? DEFAULT_LAYOUT_LABELS.KeyZ,
  Slash: layoutConfig?.forwardSpeedUpKey ?? DEFAULT_LAYOUT_LABELS.Slash,
  KeyS: layoutConfig?.KeyS ?? DEFAULT_LAYOUT_LABELS.KeyS,
  KeyD: layoutConfig?.KeyD ?? DEFAULT_LAYOUT_LABELS.KeyD,
  KeyF: layoutConfig?.KeyF ?? DEFAULT_LAYOUT_LABELS.KeyF,
  KeyK: layoutConfig?.KeyK ?? DEFAULT_LAYOUT_LABELS.KeyK,
  KeyL: layoutConfig?.KeyL ?? DEFAULT_LAYOUT_LABELS.KeyL,
  Semicolon: layoutConfig?.Semicolon ?? DEFAULT_LAYOUT_LABELS.Semicolon,
  spaceKey: layoutConfig?.spaceKey ?? DEFAULT_LAYOUT_LABELS.spaceKey,
 };
}

export function getKeyLabel(key, layoutConfig) {
 const labels = buildLabelsFromLayoutConfig(layoutConfig);
 return labels[key] || key;
}
